module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', [_c('el-tab-pane', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "作品统计",
      "name": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "706px",
      "height": "320px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "任务趋势"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "inner-right"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "clearable": false,
      "size": "small",
      "type": "year",
      "placeholder": "选择年",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.trendDataChange
    },
    model: {
      value: (_vm.trendYear),
      callback: function($$v) {
        _vm.trendYear = $$v
      },
      expression: "trendYear"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "706px",
      "height": "320px"
    },
    attrs: {
      "id": "trendChart"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e144535a!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/DataAnalysis.vue
// module id = 1000
// module chunks = 0